import httpRequest from "../../../axios/index";
import { ADMIN_DISPACHES } from "../../../constants/apiEndPoints";
import { toast } from "react-hot-toast";

const GetAllDispatche = async (
  setLoading,
  SetAllData,
  type = "",
  Search = "",
  Date = "",
  page = 1
) => {
  try {
    setLoading(true);
    let params = new URLSearchParams();

    if (type && type === "Active Jobs") {
      params.append("type", "active_jobs");
    }

    if (Search) {
      params.append("search", Search);
    }
    if (Date) {
      params.append("date", Date);
    }
    if (page) {
      params.append("page", page);
    }
    let url = `${ADMIN_DISPACHES}`;
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    const resp = await httpRequest.get(url);
    if (resp?.status === 200) {
      if (resp?.data?.message === "Success") {
        SetAllData(resp?.data);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

const GetDispatchByID = async (setLoading, SetAllData, ID = "") => {
  try {
    setLoading(true);
    const resp = await httpRequest.get(`${ADMIN_DISPACHES}/${ID}`);
    if (resp?.status === 200 && resp?.data?.message) {
      SetAllData(resp?.data);
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

const AddQuotationByID = async (setLoading, ID = "", data = "") => {
  try {
    setLoading(true);
    const resp = await httpRequest.patch(`${ADMIN_DISPACHES}/${ID}`, data);
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};
const GetAllDriversList = async (setLoading) => {
  try {
    setLoading(true);
    const resp = await httpRequest.get(`${ADMIN_DISPACHES}/drivers_list`);
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

const AssignBroadcastOrdeds = async (setLoading, ID = "", data) => {
  try {
    setLoading(true);
    const resp = await httpRequest.patch(
      `${ADMIN_DISPACHES}/${ID}/assign_job`,
      data
    );
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

export {
  GetAllDispatche,
  GetDispatchByID,
  AddQuotationByID,
  GetAllDriversList,
  AssignBroadcastOrdeds,
};
